import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    events:[],
    event:{
      name: "Kontsertgala Estonias",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec ligula mi. Quisque vitae orci vulputate, lacinia lorem quis, commodo sem. Curabitur eu sagittis orci. Donec gravida lacus ac urna tristique, a hendrerit velit gravida. Etiam sapien felis, auctor sed mattis sed, semper finibus lacus. Ut neque nulla, bibendum imperdiet odio at, elementum finibus nunc. Nulla aliquam quam ac leo elementum pretium. Sed at nulla id arcu rutrum venenatis id ut nunc. Sed feugiat scelerisque fermentum. Morbi feugiat auctor consequat. Etiam neque turpis, tempus id libero quis, porttitor mollis nibh. Fusce faucibus tempus rutrum. Integer id ultricies elit. Donec ut aliquet justo, nec iaculis lectus. Morbi et tempus magna, et ullamcorper augue. Integer sit amet laoreet nibh, quis faucibus arc.Vestibulum non mi pellentesque, feugiat urna at, volutpat magna. Sed magna nisi, consectetur sed ante id, varius condimentum dolor. Nullam non magna magna. Proin euismod velit id nulla mollis tincidunt. Praesent vitae pulvinar magna, in placerat ante. Nulla malesuada laoreet nulla. Aenean consectetur justo vitae neque vulputate, at rhoncus turpis iaculis. Etiam fringilla lacus id egestas congue. Praesent placerat est id odio pretium faucibus. Donec a metus id mi mattis vehicula non ac dui. Sed id massa odio. Ut sed mi vitae erat efficitur ornare. Quisque quis faucibus nibh, ac dapibus eros.Ut sed massa sollicitudin, pulvinar mauris ac, dignissim enim. Sed at metus eros. Quisque pulvinar fringilla erat et vehicula. Aliquam ut velit risus. Nullam non sagittis lacus. Duis finibus massa nec risus facilisis, et tempus tellus varius. Nam non est augue. Integer tincidunt augue a nunc blandit, quis posuere urna ornare. Aliquam arcu nunc, elementum in maximus quis, aliquam id augue. Proin consequat metus ac odio malesuada, sed tristique libero pellentesque. Vivamus rhoncus tincidunt sapien in eleifend. Maecenas mollis erat dui, a aliquam est tincidunt eget. Sed eu nunc in tellus maximus lobortis. Aenean vel orci fringilla, tempor lacus sed, feugiat ex. Curabitur turpis orci, eleifend ut ullamcorper et, venenatis suscipit purus. Fusce vitae erat urna.",
      codes:[
        '<iframe width="1904" height="800" src="https://www.youtube.com/embed/38h8tcMImV4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
        // '<iframe width="1904" height="743" src="https://www.youtube.com/embed/90Oc9Xl5Aps" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
      ]
    },
    editableEvents: [],
    accessToken: "",
    eventToken: "",
    serverAddress: 'https://eventmedia.evenstad.ee',
    globalNotification: '',
    success: false,
  },
  mutations: {
    SET_ACCESS_TOKEN(state, accessToken){
      state.accessToken = accessToken;
      localStorage.accessToken = accessToken;
    },
    SET_LIVE_EVENT(state, event){
      state.event = event;
    },
    SET_TICKET_LIST(state, events){
      state.events = events;
    },
    SET_EDITABLE_EVENTS(state, editableEvents){
      state.editableEvents = editableEvents;
    },
    SET_EVENT_TOKEN(state, eventToken){
      state.eventToken = eventToken;
      localStorage.eventToken = eventToken;
    },
    SET_GLOBAL_NOTIFICATION(state, payload){
      state.globalNotification = payload;
    },
    SET_SUCCESS(state, payload){
      state.success = payload;
    },
  },
  actions: {
    loginUser({commit, state, dispatch}, payload){
      return new Promise((resolve, reject) => {
        axios.post(state.serverAddress + '/login',null, {
          auth:{
            username: payload.email,
            password: payload.password
          }
        })
        .then(response => {
          if(response.status == 200){
            commit('SET_ACCESS_TOKEN', response.data.access_token);
            resolve();
          }
          else{
            if(response.status == 401){
              commit('SET_ACCESS_TOKEN', '');
            }
            dispatch('notifyUser',{globalNotification: "Wrong username and/or password!", success: false});
            reject();
          }
        })
        .catch(error => {
          if(error.response){
              if(error.response.status == 401){
                dispatch('notifyUser',{globalNotification: "Wrong username and/or password!", success: false});
                return;
              }
          }
          dispatch('notifyUser',{globalNotification: "Something went wrong while logging in!", success: false});
          reject();
        });
      });
    },
    saveEvent({commit, state, dispatch}, payload){
      return new Promise((resolve, reject) => {
        axios.post(state.serverAddress + '/events/add',payload, {
          headers: {
              Authorization: 'Bearer ' + state.accessToken
          }
        })
        .then(response => {
          if(response.status == 200){
            commit('SET_EDITABLE_EVENTS', response.data.events);
            resolve();
          }
          else{
            if(response.status == 401){
              commit('SET_ACCESS_TOKEN', '');
            }
            dispatch('notifyUser',{globalNotification: "Access token has expired!", success: false});
            reject();
          }
        })
        .catch(error => {
          if(error.response){
              if(error.response.status == 401){
                dispatch('notifyUser',{globalNotification: "Access token has expired!", success: false});
                return;
              }
          }
          dispatch('notifyUser',{globalNotification: "Something went wrong while saving event!", success: false});
          reject();
        });
      });
    },
    getEvents({commit, dispatch, state}){
      return new Promise((resolve, reject) => {
        axios.get(state.serverAddress + '/events',{
          headers: {
            Authorization: 'Bearer ' + state.accessToken
          }, 
        })
        .then(response => {
          if(response.status == 200){
            if(response.data.events){
              commit('SET_EDITABLE_EVENTS', response.data.events);
              resolve();
            }
            else{
              reject();
            }
          }
          else{
            if(response.status == 401){
              commit('SET_ACCESS_TOKEN', '');
            }
            dispatch('notifyUser',{globalNotification: "Access token has expired!", success: false});
            reject();
          }
        })
        .catch(error => {
          dispatch('notifyUser',{globalNotification: "Something went wrong while fetching events!", success: false});
          reject(error);
        });
      });      
    },
    getTicketEvents({commit, dispatch, state}){
      return new Promise((resolve, reject) => {
        axios.get(state.serverAddress + '/tickets/events')
        .then(response => {
          if(response.status == 200){
            if(response.data.events){
              commit('SET_TICKET_LIST', response.data.events);
              resolve();
            }
            else{
              reject();
            }
          }
          else{
            dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
            reject();
          }
        })
        .catch(error => {
          dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
          reject(error);
        });
      });      
    },
    buyTicket({dispatch, state}, details){
      return new Promise((resolve, reject) => {
        axios.post(state.serverAddress + '/tickets/buy',details)
        .then(response => {
          if(response.status == 200){
            if(response.data.status == "SUCCESS"){
              resolve(response.data.transaction_id);
            }
            else{
              dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
              reject();
            }
          }
          else{
            dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
            reject();
          }
        })
        .catch(error => {
          dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
          reject(error);
        });
      });      
    },
    getCodeFromTransaction({dispatch, state}, transaction_id){
      return new Promise((resolve, reject) => {
        axios.get(state.serverAddress + '/gateway/code?transaction_id=' + transaction_id)
        .then(response => {
          if(response.status == 200){
            if(response.data.code){
              resolve(response.data.code);
            }
            else{
              reject();
            }
          }
          else{
            dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
            reject();
          }
        })
        .catch(error => {
          dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
          reject(error);
        });
      });      
    },
    getEventForWatching({commit, dispatch, state}, code){
      return new Promise((resolve, reject) => {
        axios.get(state.serverAddress + '/events/watch?code=' + code)
        .then(response => {
          if(response.status == 200){
            if(response.data.event){
              commit('SET_LIVE_EVENT', response.data.event);
              resolve();
            }
            else{
              reject();
            }
          }
          else{
            dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
            reject();
          }
        })
        .catch(error => {
          dispatch('notifyUser',{globalNotification: "Unexpected error occured, please refresh the page!", success: false});
          reject(error);
        });
      });      
    },
    notifyUser({commit}, payload){
      commit('SET_GLOBAL_NOTIFICATION', payload.globalNotification);
      commit('SET_SUCCESS', payload.success);
      setTimeout(() => {
        commit('SET_GLOBAL_NOTIFICATION', '');
        commit('SET_SUCCESS', false);
      },1500);
    },
  },
  modules: {
  }
})
